import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../publish/index.scss';
import { Form, Input, Radio, DatePicker, Button, Notification, Checkbox } from 'element-react';
import { actionCreators } from './store';
import { getCookie } from '../../utils/cookie';
import http from '../../utils/request';

class Demand extends Component {

  constructor(props) {
    super(props);

    this.state = {
      form: {
        name: '',        // 技术成果名称 name
        domain: '',      // 技术成果领域 domain
        type: '',        // 需求类型
        end: null,       // 截止日期
        number: '',      // 成果编号
        address: '',     // 技术地点
        file: [],        // 文件上传
        price: '',       // 预计投入金额
        span: '',        // 关键词
        account: '',     // 技术成果简介
        des: '',         // 技术成果描述,
        innovation: '',  // 优势和创新
        application: '', // 场景应用
        profit: '',      // 预期收益
        team: '',        // 研发团队
      },
      rules: {
        name: [
          { required: true, message: '请填写技术/成果名称', trigger: 'blur' }
        ],
        domain: [
          { required: true, message: '请选择技术/成果领域', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请选择需求类型', trigger: 'change' }
        ],
        end: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        account: [
          { required: true, message: '请输入技术/成果简介', trigger: 'blur' }
        ],
        des: [
          { required: true, message: '请输入技术/成果描述', trigger: 'blur' }
        ]
      },
      disabled: false
    }
  }

  componentDidMount() {
    this.props.fecthInitData();
  }

  handleChange(key, value) {
    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value }),
      disabled: false
    });
  }

  // Submit
  handleSubmit(e) {
    e.preventDefault();

    this.setState({ disabled: true });
    const self = this;

    const { name, domain, end, address, file, price, span, account, des, innovation, application, profit, team, type } = this.state.form;
    
    const cookie = getCookie('userinfo') ? JSON.parse(getCookie('userinfo')) : '';
    const token = cookie ? cookie.token : '';

    this.refs.form.validate((valid) => {
      if (valid) {

        const parmas = {
          token: token,
          name,
          domain,
          end: end ? end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate() : null,
          address,
          file: file.toString(),
          price,
          span,
          account,
          des,
          innovation,
          application,
          profit,
          team,
          type: type.toString()
        }

        http('post', '/achieve/demand/publish', parmas).then((res) => {
          if (res.code === 200) {
            self.open(res.msg);
            setTimeout(() => {
              self.props.history.goBack();
            }, 2000);
          } else {
            self.open2(res.msg);
            setTimeout(() => {
              self.setState({ disabled: false });
            },2000);
          }
        });

      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  // submit success info-box
  open(msg) {
    Notification({
      title: '成功',
      message: msg,
      type: 'success',
      duration: 2000
    });
  }

  // submit error info-box
  open2(msg) {
    Notification.error({
      title: '错误',
      message: msg,
      duration: 2000
    });
  }

  render() {

    const { domain, demandtype } = this.props;
    const { disabled } = this.state;

    return (
      <div className="publish demand">
        <Form ref="form" labelPosition="top" model={this.state.form} rules={this.state.rules} className="publish__wrap">

          <Form.Item className="publish__item" label="需求名称" prop="name">
            <Input value={this.state.form.name} onChange={this.handleChange.bind(this, 'name')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="需求领域" prop="domain">
            <Radio.Group value={this.state.form.domain} onChange={this.handleChange.bind(this, 'domain')} className="publish__item--inner">
              {
                domain.map((item) => {
                  return (
                    <Radio value={item.get('val')} key={item.get('val')}>{item.get('name')}</Radio>
                  )
                })
              }
            </Radio.Group>
          </Form.Item>

          <Form.Item className="publish__item" label="需求类型" prop="type">
            <div className="publish__item--inner">
              <Checkbox.Group value={this.state.form.type} onChange={this.handleChange.bind(this, 'type')}>
                {
                  demandtype && demandtype.map((item) => {
                    return (
                      <Checkbox label={item.get('val')} key={item.get('val')} name="type">{item.get('name')}</Checkbox>
                    )
                  })
                }
              </Checkbox.Group>
            </div>
          </Form.Item>

          <Form.Item className="publish__item" label="预计投入金额">
            <Input value={this.state.form.price} type="number" onChange={this.handleChange.bind(this, 'price')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="截止日期">
            <div className="publish__item--inner block">
              <DatePicker
                value={this.state.form.end}
                placeholder="选择日期"
                onChange={this.handleChange.bind(this, 'end')}
                disabledDate={time => time.getTime() < Date.now() - 8.64e7}
              />
            </div>
          </Form.Item>

          <Form.Item className="publish__item" label="关键词 ( 多个关键词以分号“;”隔开 )">
            <Input value={this.state.form.span} onChange={this.handleChange.bind(this, 'span')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="需求描述" prop="des">
            <Input
              value={this.state.form.des}
              onChange={this.handleChange.bind(this, 'des')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item>
            <Button className="" type="primary" disabled={ disabled } onClick={this.handleSubmit.bind(this)}>提交</Button>
          </Form.Item>

        </Form>
      </div>
    )
  }
}

const mapState = (state) => ({
  domain: state.getIn(['demand', 'domain']),
  submitState: state.getIn(['demand', 'submitState']),
  demandtype: state.getIn(['demand', 'demandtype']),
  msg: state.getIn(['demand', 'msg'])
});

const mapDispatch = (dispatch) => ({

  fecthInitData() {
    dispatch(actionCreators.fetchDemandData());
  },

  submitFormData(obj) {
    dispatch(actionCreators.submitFormData(obj));
  }

});

export default connect(mapState, mapDispatch)(Demand);
